var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "kpi-item" },
    [
      _c(
        "div",
        {
          staticClass: "kpi-item__label typographies-paragraph-x-small-regular"
        },
        [_vm._v("\n        " + _vm._s(_vm.label) + "\n    ")]
      ),
      _vm._v(" "),
      _vm.percentage
        ? _c(
            "CompassTooltip",
            {
              attrs: {
                content: _vm.$t.__(
                  "listing.ProgressInvoiceProgressBar.progress_percentage",
                  {
                    percentage: _vm.percentage + "%"
                  }
                ),
                placement: "bottom"
              }
            },
            [
              _c("CompassProgressBar", {
                attrs: {
                  state: _vm.percentage,
                  type: "colored",
                  lowLimit: _vm.lowLimit,
                  highLimit: _vm.highLimit,
                  caption: _vm.total,
                  staticValue: _vm.amount
                }
              })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }